var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!_vm.loggedIn)?_c('h4',{staticClass:"alert alert-danger"},[_vm._v("\n    You are not authorized to access TerraTrac. Please contact your IT administrator if you\n    believe you should have access to TerraTrac.\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }